<template>
  <div class="c-material-distribute">
    <plv-dialog
      width="400px"
      show-footer-btn
      :visible="visible"
      :title="type === 'add' ? '添加用量' : '回收用量'"
      :close-on-click-mask="false"
      :closable="false"
      @confirm="handleSubmit"
      @cancel="handleDialogClose"
      @close="handleDialogClose"
    >
      <plv-form
        ref="form"
        :form="form"
        label-width="50px"
      >
        <plv-form-item label="空间">
          <template v-if="type === 'add' " slot="tips">
            <span>{{ $_getMaterialSpaceTip(form.space) }}</span>
          </template>
          <template v-else-if="type === 'recycle'" slot="tips">
            <span>{{ $_getResourceRecycleTip(assignedForm.space, 'G') }}</span>
          </template>
          <plv-input-number
            v-model="form.space"
            placeholder="请输入空间容量"
            :en-length="1"
            :max="type === 'recycle' ? assignedForm.space : availableMaterialSpace"
            :precision="0"
          >
            <template slot="suffix">
              <span class="p-material-setting-form-item__unit">GB</span>
            </template>
          </plv-input-number>
        </plv-form-item>

        <plv-form-item label="流量">
          <template v-if="type === 'add' " slot="tips">
            <span>{{ $_getMaterialFlowTip(form.flow) }}</span>
          </template>
          <template v-else-if="type === 'recycle'" slot="tips">
            <span>{{ $_getResourceRecycleTip(assignedForm.flow, 'G') }}</span>
          </template>
          <plv-input-number
            v-model="form.flow"
            placeholder="请输入流量容量"
            :en-length="1"
            :max="type === 'recycle' ? assignedForm.flow : availableMaterialTraffic"
            :precision="0"
          >
            <template slot="suffix">
              <span class="p-material-setting-form-item__unit">GB</span>
            </template>
          </plv-input-number>
        </plv-form-item>
      </plv-form>
    </plv-dialog>
  </div>
</template>

<script>
import dialogMixin from '@/mixins/dialog';
import accountInfoMixin from '@/mixins/accountInfo';
const defaultForm = {
  flow: 0,
  space: 0,
  unionId: ''
};
export default {
  mixins: [dialogMixin, accountInfoMixin],
  data() {
    return {
      type: 'add',
      form: { ...defaultForm },
      loading: false,
      assignedForm: {}
    };
  },
  methods: {
    open(type, data) {
      this.type = type;
      this.form.unionId = data.unionId;
      if (type === 'recycle') {
        this.assignedForm = {
          ...data,
          space: Math.floor(data.space || 0),
          flow: Math.floor(data.flow || 0)
        };
      }
      this.$emit('update:visible', true);
    },
    async handleSubmit() {
      if (this.loading) return;
      const isAdd = this.type === 'add';
      const form = {
        materialFlow: isAdd ? this.form.flow : -this.form.flow,
        materialSpace: isAdd ? this.form.space : -this.form.space,
        unionId: this.form.unionId
      };
      this.loading = true;
      try {
        await this.$store.dispatch('account/allocateLiveResource', form);
        // 后端重新设置有延迟
        setTimeout(async () => await this.$store.dispatch('account/getOverViewInfo'), 1000);
      } finally {
        this.loading = false;
      }
      this.$emit('updateSuccess', form);
    },
    handleDialogClose() {
      this.handleClose();
      this.form = { ...defaultForm };
    }
  }
};
</script>
